import {
    FETCH_PART_DETAILS_REQUEST,
    FETCH_PART_DETAILS_SUCCESS,
    FETCH_PART_DETAILS_FAILURE,
    CREATE_PART_DETAILS_FORM,
    UPDATE_PART_DETAILS_FORM,
    CREATE_PART_DETAILS_SUCCESS,
    FETCH_SINGLE_PART_DETAILS_SUCCESS,
    UPDATE_PART_DETAILS_SUCCESS,
    DELETE_PART_DETAILS_SUCCESS,
    CREATE_PART_DETAILS_REQUEST,
    UPDATE_PART_DETAILS_REQUEST,
    FETCH_SINGLE_PART_DETAILS_REQUEST,
    DELETE_PART_DETAILS_REQUEST,
    RESET_PART_DETAILS_INFO,
    CREATE_PART_DETAILS_FAILURE,
    UPDATE_PART_DETAILS_FAILURE,
    FETCH_SINGLE_PART_DETAILS_FAILURE,
    DELETE_PART_DETAILS_FAILURE,
    FETCH_PART_DETAILS_BY_STYLE_DETAIL_ID_SUCCESS,
    FETCH_PART_DETAILS_BY_STYLE_DETAIL_ID_REQUEST,
    FETCH_PART_DETAILS_BY_STYLE_DETAIL_ID_FAILURE,
    FETCH_FABRIC_ID_BASED_ON_FABRIC_GROUP_AND_FABRIC_TYPE_REQUEST,
    FETCH_FABRIC_ID_BASED_ON_FABRIC_GROUP_AND_FABRIC_TYPE_SUCCESS,
    FETCH_FABRIC_ID_BASED_ON_FABRIC_GROUP_AND_FABRIC_TYPE_FAILURE,
    FETCH_YARN_ID_BASED_ON_YARN_GROUP_AND_YARN_TYPE_REQUEST,
    FETCH_YARN_ID_BASED_ON_YARN_GROUP_AND_YARN_TYPE_SUCCESS,
    FETCH_YARN_ID_BASED_ON_YARN_GROUP_AND_YARN_TYPE_FAILURE,
    FETCH_PART_ID_BASED_ON_PART_NAME_ID_REQUEST,
    FETCH_PART_ID_BASED_ON_PART_NAME_ID_SUCCESS,
    FETCH_PART_ID_BASED_ON_PART_NAME_ID_FAILURE,
    RESET_PART_DETAILS_STATUS,
    FETCH_PART_DETAILS_BY_FABRIC_GROUP_REQUEST,
    FETCH_PART_DETAILS_BY_FABRIC_GROUP_SUCCESS,
    FETCH_PART_DETAILS_BY_FABRIC_GROUP_FAILURE,
    IS_EDIT,
    RESET_EDIT,
    SCREEN_KNOWS_PCS,
    RESET_PART_DETAILS_FABRIC_GROUP
} from './partDetails.actionsType';

export const PART_DETAILS = 'partDetails';

let initialState = {
    loading: false,
    partDetailsList: [],
    partDetailsListByStyle: [],
    partDetailsFabricGroup: [],
    responseStatusPartDetails: '',
    fabricIdBasedOnFabricTypeAndFabricGroup: '',
    yarnIdBasedOnYarnTypeAndYarnGroup: '',
    partIdBasedOnPartNameId: '',
    partInformationForm: {},
    selectedState: {},
    errorMessage: '',
    isEdit: false,
    isModelCheck: false
};

export let partDetailsReducer = (state = initialState, action) => {
    let { type, updatePayload, payload } = action;

    switch (type) {
        case FETCH_PART_DETAILS_REQUEST:
        case FETCH_FABRIC_ID_BASED_ON_FABRIC_GROUP_AND_FABRIC_TYPE_REQUEST:
        case FETCH_PART_DETAILS_BY_FABRIC_GROUP_REQUEST:
        case FETCH_YARN_ID_BASED_ON_YARN_GROUP_AND_YARN_TYPE_REQUEST:
        case FETCH_PART_ID_BASED_ON_PART_NAME_ID_REQUEST:
        case CREATE_PART_DETAILS_REQUEST:
        case UPDATE_PART_DETAILS_REQUEST:
        case FETCH_SINGLE_PART_DETAILS_REQUEST:
        case FETCH_PART_DETAILS_BY_STYLE_DETAIL_ID_REQUEST:
        case DELETE_PART_DETAILS_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_PART_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                partDetailsList: updatePayload
            };
        case FETCH_PART_DETAILS_BY_FABRIC_GROUP_SUCCESS:
            return {
                ...state,
                loading: false,
                partDetailsFabricGroup: updatePayload
            };
        case FETCH_FABRIC_ID_BASED_ON_FABRIC_GROUP_AND_FABRIC_TYPE_SUCCESS:
            return {
                ...state,
                loading: false,
                fabricIdBasedOnFabricTypeAndFabricGroup: updatePayload,
                partInformationForm: {
                    ...state.partInformationForm,
                    fldFKStylePrepFabric: updatePayload
                }
            };
        case RESET_PART_DETAILS_FABRIC_GROUP:
            return {
                ...state,
                partDetailsFabricGroup: []
            }
        case FETCH_YARN_ID_BASED_ON_YARN_GROUP_AND_YARN_TYPE_SUCCESS:
            return {
                ...state,
                loading: false,
                yarnIdBasedOnYarnTypeAndYarnGroup: updatePayload,
                partInformationForm: {
                    ...state.partInformationForm,
                    fldFKStylePrepYarn: updatePayload
                }
            };
        case FETCH_PART_ID_BASED_ON_PART_NAME_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                partIdBasedOnPartNameId: updatePayload,
                partInformationForm: {
                    ...state.partInformationForm,
                    fldFKPartMaster: updatePayload
                }
            };
        case FETCH_PART_DETAILS_BY_STYLE_DETAIL_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                partDetailsListByStyle: updatePayload,
                pcsError: updatePayload.some((x) => x.fldIsPCS)

            };
        case CREATE_PART_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                partInformationForm: {},
                isEdit: false
                // responseStatusPartDetails: updatePayload
            };
        case SCREEN_KNOWS_PCS:
            return {
                ...state,
                loading: false,
                isModelCheck: payload
            }
        case UPDATE_PART_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                partInformationForm: {},
                responseStatusPartDetails: updatePayload
            };
        case RESET_PART_DETAILS_STATUS:
            return {
                ...state,
                loading: false,
                responseStatusPartDetails: ''
            };
        case IS_EDIT:
            return {
                ...state,
                loading: false,
                isEdit: true
            };
        case RESET_EDIT:
            return {
                ...state,
                loading: false,
                isEdit: false
            };
        case FETCH_SINGLE_PART_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                partInformationForm: {
                    fldID: updatePayload[0]?.FldCombineID,
                    fldFKStyle: updatePayload[0]?.FldFKStyle,
                    fldFKStyleDetail: updatePayload[0]?.FldFKStyleDetail,
                    fldGSM: updatePayload[0]['SPPD'][0]?.FldGSM,
                    fldStylePrepYarnDescription: updatePayload[0]['SPPD'][0]?.FldStylePrepYarnDescription,
                    fldStylePrepFabricDescription: updatePayload[0]['SPPD'][0]?.FldStylePrepFabricDescription,
                    fldFKFabric: updatePayload[0]['SPPD'][0]?.FldFKFabric,
                    FldFKYarn: updatePayload[0]['SPPD'][0]?.FldFKYarn,
                    PrepPartDetailFldID: updatePayload[0]['SPPD'][0]?.PrepPartDetailFldID,
                    fldFKPartMaster: updatePayload[0]?.PrepPartMastersFldID,
                    fldFKPartId: updatePayload[0]?.FldPartNameId,
                    // fldFKPartDetailsId: updatePayload[0]['SPPD'][0].PrepPartDetailFldID,
                    fldFKStylePrepYarn: updatePayload[0]['SPPD'][0].FldStylePrepYarnId,
                    fldFKStylePrepFabric: updatePayload[0]['SPPD'][0].FldStylePrepFabricId,
                    fldPartName: updatePayload[0]['SPPD'][0].ppss[0].FldPartName
                }
            };
        case DELETE_PART_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                partInformationForm: {}
            };
        case RESET_PART_DETAILS_INFO:
            return {
                ...state,
                isEdit: false,
                partInformationForm: {},
                fabricIdBasedOnFabricTypeAndFabricGroup: '',
                yarnIdBasedOnYarnTypeAndYarnGroup: '',
                partIdBasedOnPartNameId: ''
            };
        case CREATE_PART_DETAILS_FORM:
        case UPDATE_PART_DETAILS_FORM:
            return {
                ...state,
                loading: false,
                partInformationForm: {
                    ...state.partInformationForm,
                    [payload.key]: payload.value
                }
            };
        case FETCH_PART_DETAILS_BY_STYLE_DETAIL_ID_FAILURE:
            return {
                partDetailsListByStyle: [],
                ...state,
                loading: false
            };
        case UPDATE_PART_DETAILS_FAILURE:
            return {
                ...state,
                loading: false,
                responseStatusPartDetails: updatePayload?.status
            };
        case FETCH_PART_DETAILS_FAILURE:
        case FETCH_FABRIC_ID_BASED_ON_FABRIC_GROUP_AND_FABRIC_TYPE_FAILURE:
        case FETCH_YARN_ID_BASED_ON_YARN_GROUP_AND_YARN_TYPE_FAILURE:
        case FETCH_PART_ID_BASED_ON_PART_NAME_ID_FAILURE:
        case CREATE_PART_DETAILS_FAILURE:
        case FETCH_SINGLE_PART_DETAILS_FAILURE:
        case DELETE_PART_DETAILS_FAILURE:
        case FETCH_PART_DETAILS_BY_FABRIC_GROUP_FAILURE:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
};
